// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-image: url('home_bg.png') !important;
}

.payment-success-content .container {
  max-width: 720px;
  margin: 0 auto;
  padding: 16px 16px 20px;
  display: flex;
  flex-direction: column;
}

.logo-section {
  text-align: center;
  margin: -10px 0 -10px;
}
.logo-section .brand-logo {
  width: 180px;
  height: 120px;
}

.success-card {
  background: white;
  padding: 18px 18px 22px;
  margin-bottom: 16px;
  border: 1px solid var(--ion-color-primary);
}

.title-message {
  text-align: center;
  margin-bottom: 8px;
  padding-bottom: 12px;
}
.title-message h1 {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  margin: 0;
  color: var(--ion-color-primary);
}

.thank-you-message {
  text-align: center;
  padding-bottom: 24px;
}
.thank-you-message h1 {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #666666;
  margin: 0;
}

.order-details {
  margin-bottom: 18px;
  padding: 14px 0;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}
.order-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.order-details .detail-row:last-child {
  margin-bottom: 0;
}
.order-details .detail-row .detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: AppFontTitle, sans-serif;
  font-size: 12px;
  color: var(--ion-color-primary);
}
.order-details .detail-row .detail-label span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-details .detail-row .detail-label ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}
.order-details .detail-row .detail-value {
  font-family: AppFontMedium, sans-serif;
  font-size: 12px;
  color: var(--ion-color-primary);
  text-align: right;
}
.order-details .detail-row .detail-value span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-details .detail-row .chip-table {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  padding-inline: 6px;
  background-color: var(--ion-color-secondary);
  border-radius: 3px;
  border: 1px solid var(--ion-color-secondary);
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--ion-color-tertiary);
}

.preparing-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: AppFontMedium;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: var(--ion-color-primary);
}
.preparing-status ion-spinner {
  width: 16px;
  height: 16px;
}

.download-receipt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--ion-color-primary);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-receipt:hover {
  background: #1a1a1a;
}
.download-receipt span {
  font-family: AppFontBold;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}
.download-receipt ion-icon {
  width: 14px;
  height: 14px;
}

.order-items {
  margin-bottom: 16px;
}
.order-items .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}
.order-items .item-row .item-info {
  display: flex;
  gap: 8px;
  flex: 1;
}
.order-items .item-row .item-info .item-quantity,
.order-items .item-row .item-info .item-name {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 127%;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  color: var(--ion-color-primary);
}
.order-items .item-row .item-info span {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 127%;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  color: var(--ion-color-primary);
}
.order-items .item-row .item-price {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 127%;
  letter-spacing: 0.01em;
  text-align: right;
  color: var(--ion-color-primary);
  white-space: nowrap;
  margin-left: 16px;
}
.order-items .item-option {
  padding-left: 32px;
  margin-bottom: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 11px;
  color: #5c5c5c;
}
.order-items .tip-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}

.miles-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
.miles-row .miles-img {
  height: 18px;
  width: auto;
}
.miles-row .miles-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #226086;
}

.total-section {
  padding: 20px 0;
  border-top: 1px solid #e5e5e5;
}
.total-section .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-section .total-row .total-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}
.total-section .total-row .total-amount {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-primary);
}

.review-section {
  text-align: center;
}
.review-section .review-button {
  width: 90%;
  height: 44px;
  margin: 0 auto;
  padding: 12px 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
  color: var(--color-white);
  border-radius: var(--radius-default);
  cursor: pointer;
  transition: background 0.2s;
}
.review-section .review-button ion-icon {
  font-size: 18px;
  color: #ffdc00;
}
.review-section .review-button .feedback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.review-section .review-button .feedback-container span {
  font-family: AppFontTitle;
  font-size: 14px;
  line-height: 135%;
  color: var(--color-white);
}

.footer-message {
  text-align: center;
  margin-bottom: 16px;
  margin-top: auto;
}
.footer-message p {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5c5c5c;
  margin: 0;
}

ion-footer {
  padding: 10px 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}
ion-footer .final-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.01em;
  text-align: center;
  color: var(--color-white);
  margin-bottom: 12px;
}

ion-button {
  min-height: 52px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .payment-success-content .container {
    height: 100%;
    padding: 16px 16px;
  }
  .success-card {
    padding: 24px 16px;
  }
}
@media (max-width: 480px) {
  .detail-row {
    align-items: flex-start !important;
    gap: 8px;
  }
  .detail-row .detail-value {
    text-align: left !important;
  }
  .order-details .detail-row .detail-label {
    font-size: 13px;
  }
  .order-details .detail-row .detail-value {
    font-size: 13px;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-overlay ion-spinner {
  width: 48px;
  height: 48px;
  color: white;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
}

.status-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}
.status-tabs .status-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.status-tabs .status-tab .status-indicator {
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  transition: background 0.3s ease;
}
.status-tabs .status-tab span {
  font-family: "AppFont", sans-serif;
  font-size: 13px;
  color: #9e9e9e;
  transition: color 0.3s ease;
}
.status-tabs .status-tab.active .status-indicator {
  background: #c6aa7a;
}
.status-tabs .status-tab.active span {
  color: #2c2c2c;
  font-weight: 600;
}
.status-tabs .status-tab:hover {
  opacity: 0.8;
}

.updated-price {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;AADD;;AAiBC;EACC,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAdF;;AAmBA;EACC,kBAAA;EACA,qBAAA;AAhBD;AAkBC;EACC,YAAA;EACA,aAAA;AAhBF;;AAqBA;EACC,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAlBD;;AAsBA;EACC,kBAAA;EACA,kBAAA;EACA,oBAAA;AAnBD;AAqBC;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;AApBF;;AAyBA;EACC,kBAAA;EACA,oBAAA;AAtBD;AAwBC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAtBF;;AA2BA;EACC,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;AAxBD;AA0BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxBF;AA0BE;EACC,gBAAA;AAxBH;AA2BE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qCAAA;EACA,eAAA;EACA,+BAAA;AAzBH;AA2BG;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AAzBJ;AA4BG;EACC,eAAA;EACA,+BAAA;AA1BJ;AA8BE;EACC,sCAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;AA5BH;AA8BG;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AA5BJ;AAmCE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EAEA,4CAAA;EACA,kBAAA;EACA,4CAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gCAAA;AAnCH;;AAyCA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,+BAAA;AAvCD;AAyCC;EACC,WAAA;EACA,YAAA;AAvCF;;AA4CA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAzCD;AA2CC;EACC,mBAAA;AAzCF;AA4CC;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA1CF;AA6CC;EACC,WAAA;EACA,YAAA;AA3CF;;AAgDA;EACC,mBAAA;AA7CD;AA+CC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AA7CF;AA+CE;EACC,aAAA;EACA,QAAA;EACA,OAAA;AA7CH;AA+CG;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,+BAAA;AA9CJ;AAiDG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,+BAAA;AAhDJ;AAoDE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EAEA,+BAAA;EACA,mBAAA;EACA,iBAAA;AAnDH;AAuDC;EACC,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AArDF;AAwDC;EACC,gBAAA;EACA,iBAAA;EACA,8BAAA;AAtDF;;AA2DA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAxDD;AA0DC;EACC,YAAA;EACA,WAAA;AAxDF;AA2DC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzDF;;AA8DA;EACC,eAAA;EACA,6BAAA;AA3DD;AA6DC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA3DF;AA6DE;EACC,oCAAA;EACA,eAAA;EACA,+BAAA;EACA,0BAAA;AA3DH;AA8DE;EACC,oCAAA;EACA,eAAA;EACA,+BAAA;AA5DH;;AAkEA;EACC,kBAAA;AA/DD;AAiEC;EACC,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,oCAAA;EACA,0CAAA;EACA,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,2BAAA;AAhEF;AAkEE;EACC,eAAA;EACA,cAAA;AAhEH;AAmEE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAjEH;AAmEG;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAjEJ;;AAwEA;EACC,kBAAA;EACA,mBAAA;EACA,gBAAA;AArED;AAuEC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AArEF;;AAyEA;EACC,uBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAvED;AAyEC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AAxEF;;AA4EA;EACC,gBAAA;EACA,eAAA;AAzED;;AA6EA;EACC;IACC,YAAA;IACA,kBAAA;EA1EA;EA6ED;IACC,kBAAA;EA3EA;AACF;AA8EA;EACC;IACC,kCAAA;IACA,QAAA;EA5EA;EA8EA;IACC,2BAAA;EA5ED;EAgFD;IACC,eAAA;EA9EA;EAiFD;IACC,eAAA;EA/EA;AACF;AAmFA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAjFD;AAmFC;EACC,WAAA;EACA,YAAA;EACA,YAAA;AAjFF;;AAsFA;EACC,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AAnFD;;AAuFA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AApFD;AAsFC;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AApFF;AAsFE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AApFH;AAuFE;EACC,kCAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AArFH;AAyFG;EACC,mBAAA;AAvFJ;AA0FG;EACC,cAAA;EACA,gBAAA;AAxFJ;AA4FE;EACC,YAAA;AA1FH;;AA+FA;EACC,gBAAA;AA5FD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground-size: cover !important;\n\tbackground-position: center center !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-attachment: fixed !important;\n\tbackground-image: url('../../../assets/luca/home_bg.png') !important;\n}\n\n.payment-success-content {\n\t// &::before {\n\t// \tcontent: '';\n\t// \tposition: fixed;\n\t// \ttop: 0;\n\t// \tleft: 0;\n\t// \tright: 0;\n\t// \tbottom: 0;\n\t// \tbackground: rgba(255, 255, 255, 0.65);\n\t// \tpointer-events: none;\n\t// \tz-index: 0;\n\t// }\n\n\t.container {\n\t\tmax-width: 720px;\n\t\tmargin: 0 auto;\n\t\tpadding: 16px 16px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n}\n\n// Logo Section\n.logo-section {\n\ttext-align: center;\n\tmargin: -10px 0 -10px;\n\n\t.brand-logo {\n\t\twidth: 180px;\n\t\theight: 120px;\n\t}\n}\n\n// Success Card\n.success-card {\n\tbackground: white;\n\tpadding: 18px 18px 22px;\n\tmargin-bottom: 16px;\n\tborder: 1px solid var(--ion-color-primary);\n}\n\n// Title Message\n.title-message {\n\ttext-align: center;\n\tmargin-bottom: 8px;\n\tpadding-bottom: 12px;\n\n\th1 {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\n\t\tmargin: 0;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n// Thank You Message\n.thank-you-message {\n\ttext-align: center;\n\tpadding-bottom: 24px;\n\n\th1 {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 12px;\n\t\tfont-weight: 400;\n\t\tline-height: 1.5;\n\t\tcolor: #666666;\n\t\tmargin: 0;\n\t}\n}\n\n// Order Details Section\n.order-details {\n\tmargin-bottom: 18px;\n\tpadding: 14px 0;\n\tborder-bottom: 1px solid #e5e5e5;\n\tborder-top: 1px solid #e5e5e5;\n\n\t.detail-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.detail-label {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 8px;\n\t\t\tfont-family: AppFontTitle, sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--ion-color-primary);\n\n\t\t\tspan {\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: inherit;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\n\t\t.detail-value {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-align: right;\n\n\t\t\tspan {\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: inherit;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\n\t\t\t.order-number {\n\t\t\t}\n\t\t}\n\n\t\t.chip-table {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\theight: 22px;\n\t\t\tpadding-inline: 6px;\n\n\t\t\tbackground-color: var(--ion-color-secondary);\n\t\t\tborder-radius: 3px;\n\t\t\tborder: 1px solid var(--ion-color-secondary);\n\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: var(--ion-color-tertiary);\n\t\t}\n\t}\n}\n\n// Preparing Status\n.preparing-status {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 14px;\n\tletter-spacing: 0.01em;\n\tcolor: var(--ion-color-primary);\n\n\tion-spinner {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n}\n\n// Download Receipt Button\n.download-receipt {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 6px 12px;\n\tbackground: var(--ion-color-primary);\n\tcolor: white;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background 0.2s;\n\n\t&:hover {\n\t\tbackground: #1a1a1a;\n\t}\n\n\tspan {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tcolor: #fff;\n\t}\n\n\tion-icon {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n// Order Items Section\n.order-items {\n\tmargin-bottom: 16px;\n\n\t.item-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 10px;\n\n\t\t.item-info {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t\tflex: 1;\n\n\t\t\t.item-quantity,\n\t\t\t.item-name {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 127%;\n\t\t\t\tletter-spacing: 0.01em;\n\t\t\t\ttext-transform: capitalize;\n\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 127%;\n\t\t\t\tletter-spacing: 0.01em;\n\t\t\t\ttext-transform: capitalize;\n\n\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\n\t\t.item-price {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 127%;\n\t\t\tletter-spacing: 0.01em;\n\t\t\ttext-align: right;\n\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\twhite-space: nowrap;\n\t\t\tmargin-left: 16px;\n\t\t}\n\t}\n\n\t.item-option {\n\t\tpadding-left: 32px;\n\t\tmargin-bottom: 8px;\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 11px;\n\t\tcolor: #5c5c5c;\n\t}\n\n\t.tip-row {\n\t\tmargin-top: 16px;\n\t\tpadding-top: 16px;\n\t\tborder-top: 1px dashed #e0e0e0;\n\t}\n}\n\n// Miles & More Section\n.miles-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 16px;\n\tpadding-top: 16px;\n\tborder-top: 1px dashed #e0e0e0;\n\n\t.miles-img {\n\t\theight: 18px;\n\t\twidth: auto;\n\t}\n\n\t.miles-value {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: #226086;\n\t}\n}\n\n// Total Section\n.total-section {\n\tpadding: 20px 0;\n\tborder-top: 1px solid #e5e5e5;\n\n\t.total-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.total-label {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-transform: capitalize;\n\t\t}\n\n\t\t.total-amount {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n// Review Section\n.review-section {\n\ttext-align: center;\n\n\t.review-button {\n\t\twidth: 90%;\n\t\theight: 44px;\n\t\tmargin: 0 auto;\n\t\tpadding: 12px 24px;\n\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 8px;\n\t\tbackground: var(--ion-color-primary);\n\t\tborder: 1px solid var(--ion-color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: var(--radius-default);\n\t\tcursor: pointer;\n\t\ttransition: background 0.2s;\n\n\t\tion-icon {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: #ffdc00;\n\t\t}\n\n\t\t.feedback-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontTitle;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 135%;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Footer Message\n.footer-message {\n\ttext-align: center;\n\tmargin-bottom: 16px;\n\tmargin-top: auto;\n\n\tp {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t\tcolor: #5c5c5c;\n\t\tmargin: 0;\n\t}\n}\n\nion-footer {\n\tpadding: 10px 20px 10px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tbox-shadow: none;\n\n\t.final-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 150%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\tcolor: var(--color-white);\n\n\t\tmargin-bottom: 12px;\n\t}\n}\n\nion-button {\n\tmin-height: 52px;\n\tfont-size: 14px;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n\t.payment-success-content .container {\n\t\theight: 100%;\n\t\tpadding: 16px 16px;\n\t}\n\n\t.success-card {\n\t\tpadding: 24px 16px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.detail-row {\n\t\talign-items: flex-start !important;\n\t\tgap: 8px;\n\n\t\t.detail-value {\n\t\t\ttext-align: left !important;\n\t\t}\n\t}\n\n\t.order-details .detail-row .detail-label {\n\t\tfont-size: 13px;\n\t}\n\n\t.order-details .detail-row .detail-value {\n\t\tfont-size: 13px;\n\t}\n}\n\n// Loading State\n.loading-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 9999;\n\n\tion-spinner {\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tcolor: white;\n\t}\n}\n\n// Error State\n.error-message {\n\tbackground: #ffebee;\n\tcolor: #c62828;\n\tpadding: 12px 16px;\n\tborder-radius: 4px;\n\tmargin-bottom: 16px;\n\ttext-align: center;\n\tfont-family: 'AppFont', sans-serif;\n\tfont-size: 14px;\n}\n\n// Status Tabs\n.status-tabs {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-bottom: 24px;\n\n\t.status-tab {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\n\t\t.status-indicator {\n\t\t\twidth: 100%;\n\t\t\theight: 10px;\n\t\t\tbackground: #e0e0e0;\n\t\t\ttransition: background 0.3s ease;\n\t\t}\n\n\t\tspan {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 13px;\n\t\t\tcolor: #9e9e9e;\n\t\t\ttransition: color 0.3s ease;\n\t\t}\n\n\t\t&.active {\n\t\t\t.status-indicator {\n\t\t\t\tbackground: #c6aa7a;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: #2c2c2c;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\topacity: 0.8;\n\t\t}\n\t}\n}\n\n.updated-price {\n\tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
